import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import { useEffect, useState } from 'react';

function TimeInputReadonly({
  type = 'MINUTE_SECOND',
  value,
  className
}: {
  type?: 'HOUR_MINUTE' | 'MINUTE_SECOND';
  value: number;
  className?: string;
}) {
  const [inputValue, setInputValue] = useState({
    hours: 0,
    minutes: 0,
    seconds: 0
  });
  const { t } = useTranslation();

  const valueToTime = (v: number) => {
    const hours = Math.floor(v / 3600);
    const minutes = Math.floor((v % 3600) / 60);
    const seconds = v % 60;
    return {
      hours,
      minutes,
      seconds
    };
  };

  useEffect(() => {
    setInputValue(valueToTime(value));
  }, [value]);

  return (
    <div
      className={classNames('py-xs', 'flex flex-row items-center justify-start gap-xxs', className)}
    >
      {type === 'HOUR_MINUTE' && inputValue.hours > 0 && (
        <div className={classNames('flex flex-row items-center justify-start gap-[2px]')}>
          <div>{inputValue.hours}</div>
          <div>{t('shared.hoursShort')}</div>
        </div>
      )}
      <div className={classNames('flex flex-row items-center justify-start gap-[2px]')}>
        <div>{inputValue.minutes}</div>
        <div>{t('shared.minutesShort')}</div>
      </div>
      {type === 'MINUTE_SECOND' && (
        <div className={classNames('flex flex-row items-center justify-start gap-[2px]')}>
          <div>{inputValue.seconds}</div>
          <div>{t('shared.secondsShort')}</div>
        </div>
      )}
    </div>
  );
}

export default TimeInputReadonly;
